import { render, staticRenderFns } from "./EditGamificationSettingsForm.vue?vue&type=template&id=724417fa&scoped=true&"
import script from "./EditGamificationSettingsForm.vue?vue&type=script&lang=ts&"
export * from "./EditGamificationSettingsForm.vue?vue&type=script&lang=ts&"
import style0 from "./EditGamificationSettingsForm.vue?vue&type=style&index=0&id=724417fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724417fa",
  null
  
)

export default component.exports